import { Common } from './index'

export default ($common: Common) => {
  return { }
}
